const autoTemplateComponent = async () => {
  // Import all modules from the /components directory if they exist
  let components = await import('../../../components/**/*.js')

  if (components) {
    const allComponents = Object.keys(components)

    allComponents.forEach((parentComponent) => {
      const childItems = Object.keys(components[parentComponent])

      // preload items that are nested under a folder first
      if (childItems?.length) {
        childItems.forEach((childComponent) => {
          if (document.getElementById('js-' + childComponent) !== null) {
            const fn =
              components?.[parentComponent]?.[childComponent] ||
              components?.[parentComponent]?.[childComponent]?.[
                childComponent
              ] ||
              components?.[parentComponent]?.[childComponent]?.[
                childComponent
              ]?.[childComponent]
            if (fn && fn instanceof Function) return fn()
          }
        })
        return
      }

      // single level items only
      if (document.getElementById('js-' + parentComponent) !== null) {
        const fn = components?.[parentComponent]?.[parentComponent]
        if (fn && fn instanceof Function) return fn()
      }
    })
  }
}

export default autoTemplateComponent
